import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { navs } from 'constants/nav';
import { INav } from 'types/INav.type';

interface INavProps {
  navClassName: string;
  iconClassName: string;
  close?: () => void;
}

const Navigation: React.FC<INavProps> = ({ navClassName, close }) => {
  const { pathname } = useLocation();

  return (
    <>
      {navs.map((item: INav) => (
        <NavLink
          to={item.path}
          key={item.path}
          className={() =>
            `${navClassName} ${pathname === item.path ? 'active' : ''}`
          }
          onClick={close}
        >
          <span
            className={`text-sm font-bold ${
              pathname === item.path ? 'text-primary-900' : 'text-black'
            }`}
          >
            {item.name}
          </span>
        </NavLink>
      ))}
    </>
  );
};
Navigation.defaultProps = {
  close: () => {}
};
export default Navigation;
